// Widget Scripts
import cardWidgetQuickLinks from './js/widgets/cardWidgetQuickLinks.js';
import cardWidgetLogoDates from './js/widgets/cardWidgetLogoDates.js';
import cardWidgetQuickNav from './js/widgets/cardWidgetQuickNav.js';
import sponsors from './js/widgets/sponsors.js';
import cardWidgetAds from './js/widgets/cardWidgetAds.js';
import videoWidget from './js/widgets/videoWidget.js';

// Custom Theme Scripts
import './js/localjs.js';
import './js/cartpopup.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    cardWidgetQuickNav();
    sponsors();
    cardWidgetAds();
    videoWidget();
  });
}

$(document).ready(function () {
  cardWidgetQuickLinks();
  cardWidgetLogoDates();
});
